import React, { useEffect, useRef, useState } from "react";
import { Quote, Star } from "lucide-react";

import priyaImg from "../assest/testimonialsimg/test1.jpg";
import lakshmiImg from "../assest/testimonialsimg/test2.jpg";
import satishImg from "../assest/testimonialsimg/test3.jpg";
import santoshImg from "../assest/testimonialsimg/test4.jpg";

const Beneficiaries = () => {
  const containerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(3);

  const stories = [
    {
      name: "Priya",
      category: "School Dental Program",
      story:
        "Identified with severe dental decay during our school camp. Received full restorative treatment free of cost.",
      image: priyaImg,
    },
    {
      name: "Mrs. Lakshmi Devi",
      category: "Senior Citizen Subsidy",
      story:
        "Lost her ability to eat comfortably. Provided subsidized dentures restoring health and smile.",
      image: lakshmiImg,
    },
    {
      name: "Mr. Satish Rao",
      category: "Rural Camp Patient",
      story:
        "Lived with chronic pain for 2 years. Emergency extraction and follow-up care provided.",
      image: satishImg,
    },
    {
      name: "Santosh",
      category: "Pediatric Care",
      story:
        "Received specialized pediatric surgery for cleft palate. All costs covered.",
      image: santoshImg,
    },
    
  ];

  // ✅ Responsive cards per view
  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;

      if (w <= 390) setCardsPerView(1);
      else if (w <= 786) setCardsPerView(2);
      else setCardsPerView(3);
    };

    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  // total pages
  const totalPages = Math.ceil(stories.length / cardsPerView);

  // Auto scroll (400ms)
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % totalPages);
    }, 2500);

    return () => clearInterval(interval);
  }, [totalPages]);

  // scroll on active change
  useEffect(() => {
    if (!containerRef.current) return;

    const scrollWidth =
      containerRef.current.scrollWidth / totalPages;

    containerRef.current.scrollTo({
      left: activeIndex * scrollWidth,
      behavior: "smooth",
    });
  }, [activeIndex, totalPages]);

  return (
    <section className="w-full py-12 md:py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4">

        {/* Header */}
        <div className="text-center mb-10">
          <span className="text-blue-500 font-bold uppercase text-xs">
            Testimonials
          </span>

          <h2 className="text-3xl md:text-5xl font-black text-slate-900">
            Who Got Benefit?
          </h2>
        </div>

        {/* Carousel */}
        <div
          ref={containerRef}
          className="flex overflow-x-hidden scroll-smooth"
        >
            {stories.map((item, index) => (
              <div
                key={index}
                className="flex-shrink-0 px-3"
                style={{ width: `${100 / cardsPerView}%` }}
              >
              <div className="bg-white rounded-2xl shadow-lg p-6 h-full">

                {/* Header */}
                <div className="relative mb-4">
                  <Quote className="absolute -top-2 -right-2 text-blue-200 w-8 h-8" />

                  <div className="flex items-center gap-4">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-16 h-16 rounded-full object-cover ring-4 ring-blue-200"
                    />

                    <div>
                      <h4 className="font-bold">{item.name}</h4>
                      <span className="text-xs text-blue-600 uppercase">
                        {item.category}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Stars */}
                <div className="flex text-yellow-400 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={16} fill="currentColor" />
                  ))}
                </div>

                {/* Story */}
                <p className="text-slate-600 italic">
                  "{item.story}"
                </p>

              </div>
            </div>
          ))}
        </div>

        {/* DOTS NAVIGATION */}
        <div className="flex justify-center mt-6 gap-2">
          {Array.from({ length: totalPages }).map((_, i) => (
            <button
              key={i}
              onClick={() => setActiveIndex(i)}
              className={`h-2 rounded-full transition-all duration-300 ${
                activeIndex === i
                  ? "w-6 bg-blue-600"
                  : "w-2 bg-gray-300"
              }`}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default Beneficiaries;